import {
  AccountBookOutlined,
  CarOutlined,
  CheckOutlined,
  DesktopOutlined,
  DollarOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import {
  useCashDrawer,
  useClientDate,
  useClientState,
  useClientStateSetter,
  useClientTheme,
  useRealmSupplierIds,
  useUser,
  useUserBusinessCode,
} from "@easybiz/component-shared";
import {
  DISPLAY_MODE_CHECK_IN,
  DISPLAY_MODE_CHECK_OUT,
  DISPLAY_MODE_COLLECTION,
  DISPLAY_MODE_CONFIRM_ORDER,
  DISPLAY_MODE_PRODUCTION,
  DISPLAY_MODE_SALES,
  SALES_CHANNEL_TYPE_STORE,
} from "@easybiz/utils";
import { LocationMonitor, OfflineAlert, OrderDrawer, SystemNoticeBanner, WebCheckout } from "@easybiz/web-admin";
import { Space } from "antd";
import React from "react";
import CashDrawerButton from "./components/CashDrawerButton";
import CollectionOptionsLoader from "./components/CollectionOptionsLoader";
import POSDisplayModeButton from "./components/POSDisplayModeButton";
import POSHomeLeftPanel from "./components/POSHomeLeftPanel";
import POSHomeRightPanel from "./components/POSHomeRightPanel";

export default function POSWebApplication() {
  const businessCode = useUserBusinessCode();
  const user = useUser();
  const cashDrawer = useCashDrawer();
  const secondaryContainer = useClientTheme()?.surface;
  const setState = useClientStateSetter();
  const supplierIds = useRealmSupplierIds();
  const date = useClientDate();
  const { openOrderId } = useClientState();

  return (
    <WebCheckout newOrderType={SALES_CHANNEL_TYPE_STORE} businessCode={businessCode} date={date}>
      <div className="flex full-screen">
        <OfflineAlert />
        <SystemNoticeBanner />
        {user?.multiStation && <LocationMonitor />}
        <div className="flex flex-fill flex-row scroll-container">
          <div className="flex flex-fill">
            <POSHomeLeftPanel />
            <div className="flex flex-row flex-space-between flex-align-center padding-half">
              <Space>
                <POSDisplayModeButton targetMode={DISPLAY_MODE_CONFIRM_ORDER} icon={<AccountBookOutlined />} />
                <POSDisplayModeButton targetMode={DISPLAY_MODE_CHECK_OUT} icon={<ShopOutlined />} />
                <POSDisplayModeButton targetMode={DISPLAY_MODE_CHECK_IN} icon={<CarOutlined />} />
                <POSDisplayModeButton targetMode={DISPLAY_MODE_COLLECTION} icon={<CheckOutlined />} />
                {supplierIds?.length > 0 && (
                  <POSDisplayModeButton targetMode={DISPLAY_MODE_PRODUCTION} icon={<DesktopOutlined />} />
                )}
              </Space>
              <Space>
                <POSDisplayModeButton targetMode={DISPLAY_MODE_SALES} icon={<DollarOutlined />} />
                <CashDrawerButton />
              </Space>
            </div>
          </div>
          <div
            className="flex"
            style={{ width: 470, minWidth: 470, padding: "8px 8px 0px 8px", background: secondaryContainer }}
          >
            <POSHomeRightPanel />
          </div>
          <OrderDrawer
            cashDrawer={cashDrawer}
            placement={"right"}
            orderId={openOrderId}
            open={Boolean(openOrderId)}
            onClose={() => setState({ openOrderId: null })}
          />
          <CollectionOptionsLoader />
        </div>
      </div>
    </WebCheckout>
  );
}
